import { render, staticRenderFns } from "./tokenvalidate.vue?vue&type=template&id=770115f0"
import script from "./tokenvalidate.vue?vue&type=script&lang=js"
export * from "./tokenvalidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports